
<div class="courses-panel">

    <div class="header">

        <h2 class="title">All Courses</h2>

        <button mat-mini-fab color="accent">
            <mat-icon class="add-course-btn">add</mat-icon>
        </button>

    </div>

    <mat-tab-group>

        <mat-tab label="Beginners">

        </mat-tab>

        <mat-tab label="Advanced">

        </mat-tab>

    </mat-tab-group>

</div>

